import { all, takeEvery, call, put, fork } from 'redux-saga/effects';
import gocarActions from './actions';
import callApi from '../../helpers/api';

export function* getBrandsRequest() {
  yield takeEvery('GET_BRANDS', function*() {
      let res = yield call(callApi.getBrands);
      if (res) {
        yield put({type: gocarActions.DATA_BRANDS, data: res.data})
      }
  });
}

export function* getModelsRequest() {
  yield takeEvery('GET_MODELS', function*(payload) {
      let res = yield call(callApi.getModels, payload);
      if (res) {
        yield put({type: gocarActions.DATA_MODELS, data: res.data})
      }
  });
}

export function* getYearsRequest() {
  yield takeEvery('GET_YEAR', function*(payload) {
      let res = yield call(callApi.getYears, payload);
      if (res) {
        yield put({type: gocarActions.DATA_YEAR, data: res.data})
      }
  });
}

// export function* getInsuranceSuccess() {
//   yield takeEvery(actions.GET_INSURANCE_DATA, function*() {

//   });
// }

export default function* rootSaga() {
  yield all([
    fork(getBrandsRequest),
    fork(getModelsRequest),
    fork(getYearsRequest)
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/gocar/saga.js